import React from 'react';
import ContractContainer from '../../../components/containers/ContractPage';

export default function ContractsPageContractor() {
  return <ContractContainer title="Contratos" />;
}
